<!--
PAGE LOADING
-->
<div *ngIf="pageLayoutDataService.loading" [ngStyle]="{'height': (canvasLayoutDataService.viewportHeight-canvasLayoutDataService.headerHeight)+'px'}" class="layout vertical center middle">
    <app-loading-screen></app-loading-screen>
</div>
<!--
PAGE CONTENT
-->
<ng-container *ngIf="!pageLayoutDataService.loading">
    <!--
    LAYOUT 0: nessuna formattazione
    -->
    <ng-container *ngIf="pageLayoutDataService.layoutType==0">
        <div *ngIf="pageLayoutDataService.showBreadcrumbs && routingDataService.currentBreadcrumbs" 
             style="width: 100%; height: 48px; margin-bottom: 5px;">
            <app-breadcrumbs></app-breadcrumbs>
        </div>
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </ng-container>
    <!--
    LAYOUT 1: consigliato per i form
              tutto, compresi gli eventuali breadcrumbs, rimane centrato orizzontalmente
              se c'è abbastanza spazio (no mobile) il form viene wrappato con una card
    -->
    <ng-container *ngIf="pageLayoutDataService.layoutType==1">
        <div *ngIf="!isXxxs" style="width: 100%;">
            <div *ngIf="pageLayoutDataService.showBreadcrumbs && routingDataService.currentBreadcrumbs" 
                 style="width: 100%; height: 48px; margin-bottom: 5px;">
                <app-breadcrumbs></app-breadcrumbs>
            </div>
            <div style="margin: auto;" [ngStyle]="{'max-width': pageLayoutDataService.notMobileMaxWidth+'px'}">
                <app-card>
                    <ng-container [ngTemplateOutlet]="content"></ng-container>
                </app-card>
                <br>
                <br>
            </div>
        </div>
        <div *ngIf="isXxxs" style="width: 100%; padding: 8px;">
            <!-- <div *ngIf="pageLayoutDataService.showBreadcrumbs && routingDataService.currentBreadcrumbs" 
                 style="width: 100%; height: 48px; margin-bottom: 5px;">
                <app-breadcrumbs></app-breadcrumbs>
            </div> -->
            <ng-container [ngTemplateOutlet]="content"></ng-container>
        </div>
    </ng-container>
     <!--
    LAYOUT 2: consigliato per le pagine con grid:
              tutto, compresi gli eventuali breadcrumbs, rimane centrato orizzontalmente
    -->
    <div *ngIf="pageLayoutDataService.layoutType==2" class="layout vertical center top">
        <div *ngIf="pageLayoutDataService.showBreadcrumbs && routingDataService.currentBreadcrumbs" 
            style="width: 100%; height: 48px; margin-bottom: 5px;">
            <app-breadcrumbs></app-breadcrumbs>
        </div>
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>

    <app-fab-button-set *ngIf="pageLayoutDataService.showFabButtons"
                    [primaryAction]="pageLayoutDataService.fabButtonSetPrimaryAction"
                    [secondaryActions]="pageLayoutDataService.fabButtonSetSecondaryActions" 
                    (buttonClick)="pageLayoutDataService.manageFabButtonSetClick($event)">
    </app-fab-button-set>
</ng-container>
